import { ORGANIZATION_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const OrganizationServices = {
  fetchOrganizations: async (params: any) => {
    const response = await axiosClient.get(`${ORGANIZATION_API_URL}`, {
      params
    });
    return response.data;
  },
  createOrganization: async (body: any) => {
    try {
      const response = await axiosClient.post(`${ORGANIZATION_API_URL}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  deleteOrganization: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${ORGANIZATION_API_URL}`, {
        params
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  updateOrganization: async (body: any, orgId: any) => {
    try {
      const response = await axiosClient.put(`${ORGANIZATION_API_URL}/${orgId}`, body);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  },
  downloadOrganization: async () => {
    try {
      const response = await axiosClient.get(`${ORGANIZATION_API_URL}/download`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data;
    }
  }
};

export default OrganizationServices;
